module.exports = __webpack_public_path__ + "static/media/servicerocket.246fbbde.svg";